import request from '../request'
import requestUrl from '../requestUrl'
import requestParam from '../requestParam'
import { serviceWithHeader } from '../request'

export const statusList = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/queryAccountStatus'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updateStatus = params => {
    return request({
        url: requestUrl('/sys/clientStatAccState/updateAccountStatus'),
        method: 'post',
        data: requestParam(params)
    })
}


export const exportAccState = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}


export const getStatusList = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/statutoryList'),
        method: 'post',
        data: requestParam(params)
    })
}

export const listTableColumn = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/listTableColumn'),
        method: 'post',
        data: requestParam(params)
    })
}

export const exportStatutoryList = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/exportStatutoryList'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

export const getStatutoryMessage = params => {
    return request({
        url: requestUrl('/client/statutoryMessage'),
        method: 'get',
        params: params
    })
}

export const deleteStatutoryMessage = params => {
    return request({
        url: requestUrl('/client/statutoryMessage'),
        method: 'delete',
        data: requestParam(params)
    })
}
export const postStatutoryMessage = params => {
    return request({
        url: requestUrl('/client/statutoryMessage'),
        method: 'post',
        data: requestParam(params)
    })
}

function getError(action, option, xhr) {
    let msg;
    if (xhr.response) {
      msg = `${xhr.response.error || xhr.response}`;
    } else if (xhr.responseText) {
      msg = `${xhr.responseText}`;
    } else {
      msg = `fail to post ${action} ${xhr.status}`;
    }

    const err = new Error(msg);
    err.status = xhr.status;
    err.method = 'post';
    err.url = action;
    return err;
  }

  function getBody(xhr) {
    const text = xhr.responseText || xhr.response;
    if (!text) {
      return text;
    }

    try {
      return JSON.parse(text);
    } catch (e) {
      return text;
    }
  }
export const uploadSASFiles = option => {
    if (typeof XMLHttpRequest === 'undefined') {
        return false
    }

    const xhr = new XMLHttpRequest()
    const action = requestUrl('/client/clientStatAccState/uploadStatutoryFile')

    if (xhr.upload) {
        xhr.upload.onprogress = function progress(e) {
            if (e.total > 0) {
                e.percent = e.loaded / e.total * 100
            }
            option.onProgress && option.onProgress(e)
        }
    }

    const formData = new FormData();

    if (option.data) {
        Object.keys(option.data).forEach(key => {
            formData.append(key, option.data[key])
        })
    }

    formData.append('file', option.file, option.file.name ? option.file.name : '')

    xhr.onerror = function error(e) {
        option.onError && option.onError(e)
    }

    xhr.onload = function onload() {
        if (xhr.status < 200 || xhr.status >= 300) {
            return option.onError && option.onError(getError(action, option, xhr))
        }


        option.onSuccess && option.onSuccess(getBody(xhr))
    }

    xhr.open('post', action, true)

    if (option.withCredentials && 'withCredentials' in xhr) {
      xhr.withCredentials = true
    }


    const headers = {
        Authorization: sessionStorage.getItem('JSESSIONID'),
        siteClassification: sessionStorage.getItem('siteClassification')
    }

    for (let item in headers) {
      if (headers.hasOwnProperty(item) && headers[item] !== null) {
        xhr.setRequestHeader(item, headers[item])
      }
    }
    xhr.send(formData)
    return xhr
}

export const singleDownloadAccState = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/downloadStatutoryFile'),
        method: 'post',
        data: params,
        responseType: 'blob'
    })
}
export const batchDownloadAccState = params => {
    return serviceWithHeader({
        url: requestUrl('/client/clientStatAccState/downloadStatutoryFiles'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}
export const switchAttachmentVisible = params => {
    return request({
        url: requestUrl('/sys/clientStatAccState/switchAttachmentVisible'),
        method: 'post',
        data: params,
    })
}
export const updateStatutoryRecord = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/updateStatutoryRecord'),
        method: 'post',
        data: requestParam(params),
    })
}
export const updateStatutoryRecordDate = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/updateStatutoryRecordDate'),
        method: 'post',
        data: requestParam(params),
    })
}
export const dashboardTimeAllocation = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/dashboardTimeAllocation'),
        method: 'post',
        data: requestParam(params),
    })
}
export const dashboardStatusOverview = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/dashboardStatusOverview'),
        method: 'post',
        data: requestParam(params),
    })
}
export const queryKPMemberBySite = params => {
    return request({
        url: requestUrl('/user/queryKPMemberBySite'),
        method: 'post',
        data: requestParam(params),
    })
}
export const clientStatAccStateSendEmail = params => {
    return request({
        url: requestUrl('/sys/clientStatAccState/sendEmail'),
        method: 'post',
        data: requestParam(params),
    })
}
export const deleteFiles = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/deleteFiles'),
        method: 'post',
        data: requestParam(params),
    })
}
export const checkDownLoadLimit = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/checkDownLoadLimit'),
        method: 'post',
        data: requestParam(params),
    })
}
export const querySavedCondition = params => {
    return request({
        url: requestUrl('/client/clientStatAccState/querySavedCondition'),
        method: 'post',
        data: params,
    })
}

export const queryTodayCount  = (params) => {
    return request({
        url: requestUrl('/client/statutoryMessage/queryTodayCount'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryTodayCommentInfos = (params) => {
    return request({
        url: requestUrl('/client/clientStatAccState/queryTodayCommentInfos'),
        method: 'post',
        data: requestParam(params)
    })
}


